var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.persona.nombre)+" "+_vm._s(_vm.persona.apellido))]),_c('td',[_vm._v(_vm._s(_vm.persona.email))]),_c('td',[_vm._v(_vm._s(_vm.persona.perfil))]),_c('td',[_vm._v("Cuota # "+_vm._s(_vm.persona.cuota_numero))])])
}
var staticRenderFns = []

export { render, staticRenderFns }